import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import Animations from "../../../themes/Animations";

const BADGE_DIAMETER = "12px";

const BadgeContainer = styled.div`
    position: relative;
`;

const StyledBadge = styled.span<{ glow: boolean; top?: number; right?: number }>(
    ({ glow, top, right }) => css`
        position: absolute;
        top: ${top ?? 0}px;
        right: ${right ?? 0}px;
        transform: translateX(25%) translateY(-25%);

        height: ${BADGE_DIAMETER};
        width: ${BADGE_DIAMETER};
        background-color: #a4c8ff;
        border-radius: 50%;
        display: inline-block;

        ${glow &&
        css`
            animation: ${Animations.glow};
        `}
    `,
);

interface LifeAtNotificationBadgeProps {
    children?: ReactNode;
    show: boolean;
    glow: boolean;
    top?: number;
    right?: number;
}
export default function LifeAtNotificationBadge(props: LifeAtNotificationBadgeProps) {
    return (
        <BadgeContainer>
            {props.children}
            {props.show ? (
                <StyledBadge className={`notification-badge`} glow={props.glow} top={props.top} right={props.right} />
            ) : null}
        </BadgeContainer>
    );
}
